export default {
  isShowMenu: false,
  isDisplayOtherVessels: true,
  onAlertSummaryNotification: true,
  onVesselAutoTracking: false,
  trackDisplayInterval: 60,
  trackHistoryInterval: 60,
  showDialogSelectVessel: false,
}
